// extracted by mini-css-extract-plugin
export var formContainer = "_kz-0";
export var message = "_kz-1";